const partnerOptions = [
    { id: "1", label: "COPART" },
    { id: "2", label: "IAAI" },
];

  // API key
  const partnerAPIKey = "site"; 
  
  // Label
  const partnerLabel = "Auction Type"; 
  
  export { partnerOptions, partnerAPIKey, partnerLabel };
  